import Stop1 from '../../../images/stop-markers/stop-1.svg';
import Stop2 from '../../../images/stop-markers/stop-2.svg';
import Stop3 from '../../../images/stop-markers/stop-3.svg';
import Stop4 from '../../../images/stop-markers/stop-4.svg';
import Stop5 from '../../../images/stop-markers/stop-5.svg';
import Stop6 from '../../../images/stop-markers/stop-6.svg';
import Stop7 from '../../../images/stop-markers/stop-7.svg';
import Stop8 from '../../../images/stop-markers/stop-8.svg';
import Stop9 from '../../../images/stop-markers/stop-9.svg';
import Stop10 from '../../../images/stop-markers/stop-10.svg';
import Stop11 from '../../../images/stop-markers/stop-11.svg';
import Stop12 from '../../../images/stop-markers/stop-12.svg';
import Stop13 from '../../../images/stop-markers/stop-13.svg';
import Stop14 from '../../../images/stop-markers/stop-14.svg';
import Stop15 from '../../../images/stop-markers/stop-15.svg';
import Stop16 from '../../../images/stop-markers/stop-16.svg';
import Stop17 from '../../../images/stop-markers/stop-17.svg';
import Stop18 from '../../../images/stop-markers/stop-18.svg';
import Stop19 from '../../../images/stop-markers/stop-19.svg';
import Stop20 from '../../../images/stop-markers/stop-20.svg';

import EndTour from '../../../images/stop-markers/end-tour.svg';
import StartTour from '../../../images/stop-markers/start-tour.svg';

import Stop1Alt from '../../../images/stop-markers/alt-color/stop-1.svg';
import Stop2Alt from '../../../images/stop-markers/alt-color/stop-2.svg';
import Stop3Alt from '../../../images/stop-markers/alt-color/stop-3.svg';
import Stop4Alt from '../../../images/stop-markers/alt-color/stop-4.svg';
import Stop5Alt from '../../../images/stop-markers/alt-color/stop-5.svg';
import Stop6Alt from '../../../images/stop-markers/alt-color/stop-6.svg';
import Stop7Alt from '../../../images/stop-markers/alt-color/stop-7.svg';
import Stop8Alt from '../../../images/stop-markers/alt-color/stop-8.svg';
import Stop9Alt from '../../../images/stop-markers/alt-color/stop-9.svg';
import Stop10Alt from '../../../images/stop-markers/alt-color/stop-10.svg';
import Stop11Alt from '../../../images/stop-markers/alt-color/stop-11.svg';
import Stop12Alt from '../../../images/stop-markers/alt-color/stop-12.svg';
import Stop13Alt from '../../../images/stop-markers/alt-color/stop-13.svg';
import Stop14Alt from '../../../images/stop-markers/alt-color/stop-14.svg';
import Stop15Alt from '../../../images/stop-markers/alt-color/stop-15.svg';
import Stop16Alt from '../../../images/stop-markers/alt-color/stop-16.svg';
import Stop17Alt from '../../../images/stop-markers/alt-color/stop-17.svg';
import Stop18Alt from '../../../images/stop-markers/alt-color/stop-18.svg';
import Stop19Alt from '../../../images/stop-markers/alt-color/stop-19.svg';
import Stop20Alt from '../../../images/stop-markers/alt-color/stop-20.svg';

import EndTourAlt from '../../../images/stop-markers/alt-color/end-tour.svg';
import StartTourAlt from '../../../images/stop-markers/alt-color/start-tour.svg';

let Stops = [
    Stop1,
    Stop2,
    Stop3,
    Stop4,
    Stop5,
    Stop6,
    Stop7,
    Stop8,
    Stop9,
    Stop10,
    Stop11,
    Stop12,
    Stop13,
    Stop14,
    Stop15,
    Stop16,
    Stop17,
    Stop18,
    Stop19,
    Stop20
];
let AltColorStops = [
    Stop1Alt,
    Stop2Alt,
    Stop3Alt,
    Stop4Alt,
    Stop5Alt,
    Stop6Alt,
    Stop7Alt,
    Stop8Alt,
    Stop9Alt,
    Stop10Alt,
    Stop11Alt,
    Stop12Alt,
    Stop13Alt,
    Stop14Alt,
    Stop15Alt,
    Stop16Alt,
    Stop17Alt,
    Stop18Alt,
    Stop19Alt,
    Stop20Alt
];

export default { AltColorStops, Stops, EndTour, StartTour, EndTourAlt, StartTourAlt };



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/StopIndex.ts